// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"89520505","453":"817673cc","455":"98a3267c"}[chunkId] + ".chunk.js";
};